import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { AuthenticationService } from '../auth/authentication.service';



@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
        const user = this.authenticationService.userValue;
        const isApiUrl = request.url.startsWith(environment.apiBaseUrl);
        if (user && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    authorization: `Bearer ${user}`
                }
            });
        }
        return next.handle(request);
    }
}